import { render } from "./EditCalendarDayView.vue?vue&type=template&id=0add7db6&scoped=true"
import script from "./EditCalendarDayView.vue?vue&type=script&lang=js"
export * from "./EditCalendarDayView.vue?vue&type=script&lang=js"

import "./EditCalendarDayView.vue?vue&type=style&index=0&id=0add7db6&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0add7db6"]])

export default __exports__